import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ spacing, breakpoints }) => ({
  footer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: spacing(4),
    padding: spacing(6, 6, 0, 6),

    [`@media (max-width: ${breakpoints.values.tablet}px)`]: {
      padding: spacing(3, 3, 0, 3)
    }
  },
  logo: {
    height: 20,
    width: "auto",
    marginRight: spacing(2)
  }
}))
